const VERTICAL_DOTTED_BORDER_STYLE = Object.freeze({
  color: Object.freeze([190, 190, 185]),
  width: 0.15,
  dash: Object.freeze([0.8, 0.8])
});

export function drawVerticalDottedCellBorder(doc, data) {
  const columns = data?.table?.columns;
  const cell = data?.cell;
  if (!doc || !cell || !Array.isArray(columns) || columns.length === 0) return;

  const columnIndex = Number(data?.column?.index);
  const colSpan = Number(cell.colSpan) || 1;
  if (!Number.isInteger(columnIndex) || columnIndex + colSpan >= columns.length) return;

  const cellRight = cell.x + cell.width;
  doc.setDrawColor(...VERTICAL_DOTTED_BORDER_STYLE.color);
  doc.setLineWidth(VERTICAL_DOTTED_BORDER_STYLE.width);
  doc.setLineDashPattern([...VERTICAL_DOTTED_BORDER_STYLE.dash], 0);
  doc.line(cellRight, cell.y, cellRight, cell.y + cell.height);
  doc.setLineDashPattern([], 0);
}
